import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import LoginPage from '../pages/LoginPage.vue';
import Home from "@/pages/Home.vue";
import showLocation from "@/pages/ShowLocation.vue";
import showLocationOverTime from "@/pages/ShowLocationOverTime.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/location',
    name: 'location',
    component: showLocation,
    props: true
  },
  {
    path: '/locationOverTime',
    name: 'locationOverTime',
    component: showLocationOverTime,
    props: true
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    props: true
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    props: true
  },
  {
    path: '/',
    name: 'main',
    component: Home,
    props: true
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
